import { render, staticRenderFns } from "./serviceAccount.vue?vue&type=template&id=5703981a&scoped=true&"
import script from "./serviceAccount.vue?vue&type=script&lang=js&"
export * from "./serviceAccount.vue?vue&type=script&lang=js&"
import style0 from "./serviceAccount.vue?vue&type=style&index=0&id=5703981a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5703981a",
  null
  
)

export default component.exports